/**
 * Escape single quotes to keep SQL string literals valid
 * @param s - The string to escape
 * @returns The escaped string
 */
export const escapeSqlSingleQuote = (s: string) => s.replaceAll("'", "''");
